import React from "react"
import {FieldFormElementViewProps} from "../../../../render/form-elemnent-view";
import DropdownFormView from "./components/form";


export default function FieldDropdown_FormElementView(props: FieldFormElementViewProps) {

    const value = props.model[props.field.fieldId]

    return <DropdownFormView className      = {props.className}
                             field          = {props.field}
                             model          = {props.model}
                             value          = {value}
                             configOptions  = {props.options}
                             disabled       = {props.disabled}
                             onChange       = {props.onChange}/>

}